function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import * as React from "react";
function Send(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.93 1.293c.278.278.367.695.227 1.063L15.45 22.58c-.148.387-.52.643-.935.643h-.006a1 1 0 01-.932-.654l-3.206-8.716-8.717-3.207a1.001 1.001 0 01-.01-1.873l20.223-7.707a1 1 0 011.063.228zM20.494 3.73L4.851 9.69l6.044 2.223 3.227-3.226a1 1 0 011.414 1.414l-3.227 3.226 2.223 6.044L20.494 3.73z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}
const MemoSend = /*#__PURE__*/React.memo(Send);
export default MemoSend;